import jQuery from 'jquery';
import reject from 'lodash/reject';
import EventService from '../common/event/EventService';
import HttpService from '../common/http/HttpService';
import PortalEvent from '../vcom/events/PortalEvent';
import PortletEvent from '../vcom/events/PortletEvent';
import translate from '../common/localization/translate';
import Portlet from './Portlet';
import '../vendor/jquery/jquery.ui-1.8.portlet';
import VcomSection from '../vcom/const/VcomSection';
import { PortletEndpoint } from '../common/endpoints/modules/portlets/PortletEndpoint';

export default function Portal() {
  let portlets = [];
  const columns = 24;
  const rows = 24;
  let columnWidth = 0;
  let rowHeight = 0;
  let contentHeight = null;
  let contentWidth = null;
  let loadedAsyncScripts = [];

  function getColumns() {
    return columns;
  }

  function getRows() {
    return rows;
  }

  function getColumnWidth() {
    return columnWidth;
  }

  function getRowHeight() {
    return rowHeight;
  }

  function addPermissionToPortlet(acl, section) {
    const options = {};
    options.draggable = acl.isAllowed('update');
    options.closeable = ![
      VcomSection.ANALYSIS,
      VcomSection.CALENDAR,
      VcomSection.DOCUMENTS,
    ].includes(section);
    options.closeable = options.closeable ? acl.isAllowed('delete') : options.closeable;
    options.configurable = acl.isAllowed('update');
    options.resizable = acl.isAllowed('update');
    options.titlebar = section !== VcomSection.CALENDAR;

    return options;
  }

  function updatePortalDimensions() {
    jQuery('.portal').height(VCOM.Layout.getContentHeightCompatibleWithRowHeight());
    jQuery('.portal').width(VCOM.Layout.getContentWidthCompatibleWithColumnWidth());
  }

  function calculateGrid() {
    columnWidth = VCOM.Layout.getContentWidthCompatibleWithColumnWidth() / columns;
    rowHeight = VCOM.Layout.getContentHeightCompatibleWithRowHeight() / rows;
  }

  function hasContentHeightChanged() {
    if (contentHeight === VCOM.Layout.getContentHeight()) {
      return false;
    }
    contentHeight = VCOM.Layout.getContentHeight();
    return true;
  }

  function hasContentWidthChanged() {
    if (contentWidth === VCOM.Layout.getContentWidth()) {
      return false;
    }
    contentWidth = VCOM.Layout.getContentWidth();
    return true;
  }

  function resize() {
    calculateGrid();
    updatePortalDimensions();

    portlets.forEach((portlet) => {
      const elPortlet = jQuery(`#${portlet.uid}`);
      const aGridPosition = portlet.getGridPosition();

      const x1 = aGridPosition[0][0];
      const y1 = aGridPosition[0][1];
      const x2 = aGridPosition[1][0];
      const y2 = aGridPosition[1][1];

      elPortlet.portlet('option', 'position', [
        columnWidth * x1,
        rowHeight * y1,
      ]);

      elPortlet.portlet('option', 'height', rowHeight * (y2 - y1));
      elPortlet.portlet('option', 'width', columnWidth * (x2 - x1));
      elPortlet.portlet('option', 'grid', [columnWidth, rowHeight]);
      elPortlet.portlet('option', 'maxWidth', columnWidth * columns);
      elPortlet.portlet('option', 'maxHeight', rowHeight * rows);

      EventService.dispatch(PortletEvent.RESIZED, { target: document.getElementById(portlet.uid) });
    });
  }

  function resizePortal() {
    if (hasContentHeightChanged() || hasContentWidthChanged()) {
      resize();
    }
  }

  function bindListeners() {
    EventService.addListener(PortalEvent.DIMENSIONS_CHANGED, { callback: resizePortal });
    jQuery(window).on('resize', resizePortal);
  }

  function registerPortlet(portlet) {
    portlets = portlets.concat(portlet);
  }

  async function removePortlet(portlet) {
    portlets = reject(portlets, { uid: portlet.uid });
    if (portlet.isPersistent === false) {
      return;
    }
    await HttpService.post(PortletEndpoint.REMOVE_PORTLET, { portletId: portlet.uid.split('_')[1] });
  }

  function hasBundleLink(bundleLink) {
    return jQuery(`link[href="${bundleLink}"]`).length > 0;
  }

  function addBundleLink(bundleLink) {
    jQuery('<link/>', {
      rel: 'stylesheet',
      type: 'text/css',
      href: bundleLink,
    }).appendTo('head');
  }

  function hasScript(script) {
    return jQuery(`[src="${script}"]`).length > 0 || loadedAsyncScripts.includes(script);
  }

  function getScript(url) {
    const deferred = jQuery.Deferred();
    jQuery.getScript(url, () => {
      loadedAsyncScripts = loadedAsyncScripts.concat(url);
      deferred.resolve(true);
    });
    return deferred;
  }

  async function loadAsyncResources(data) {
    const {
      bundleLinks,
      entryPoints,
    } = data;

    bundleLinks.forEach((bundleLink) => {
      if (hasBundleLink(bundleLink) === false) {
        addBundleLink(bundleLink);
      }
    });

    const entryPointsWithoutScripts = entryPoints.filter(
      (entryPoint) => hasScript(entryPoint) === false,
    );
    const entryPointScripts = entryPointsWithoutScripts.map(getScript);
    await Promise.all(entryPointScripts);
  }

  async function updatePortletPosition(portlet) {
    if (portlet.isPersistent === false) {
      return;
    }
    await HttpService.post(PortletEndpoint.UPDATE_PORTLET_POSITION, {
      portletUId: portlet.uid.split('_')[1],
      position: portlet.getGridPosition(),
    });
  }

  function initPortlet(el, options) {
    const $el = jQuery(el);
    const view = ($el.attr('class').split('_')[1]).split(' ')[0] || 'library';
    const aGridPosition = JSON.parse($el.attr('rel'));
    const portletId = JSON.parse($el.data('portlet-id'));
    const { isPersistent = true } = options;
    const portlet = new Portlet(el.id, {
      view,
      gridPosition: aGridPosition,
      isPersistent,
    });

    registerPortlet(portlet);

    // temp variables for faster access
    const x1 = aGridPosition[0][0];
    const y1 = aGridPosition[0][1];
    const x2 = aGridPosition[1][0];
    const y2 = aGridPosition[1][1];

    const opts = jQuery.extend({
      bgiframe: () => jQuery('.anlagenschema', $el).length > 0,
      maxWidth: columnWidth * columns,
      maxHeight: rowHeight * rows,
      position: [
        columnWidth * x1,
        rowHeight * y1,
      ],
      width: columnWidth * (x2 - x1),
      height: rowHeight * (y2 - y1),
      grid: [
        columnWidth,
        rowHeight,
      ],
      dragStart: () => {
        EventService.dispatch(PortletEvent.DRAG_STARTED, { target: el });
      },
      dragStop: (event) => {
        if (!jQuery(event.target).data('ui-portlet').isMaximized()) {
          portlet.updateGridPosition();
          updatePortletPosition(portlet);
        }
        EventService.dispatch(PortletEvent.DRAG_STOPPED, { target: el });
      },
      resize: () => {
        EventService.dispatch(PortletEvent.RESIZED, { target: el });
      },
      resizeStop: () => {
        if (!jQuery(el).data('ui-portlet').isMaximized()) {
          portlet.updateGridPosition();
          updatePortletPosition(portlet);
        }
        EventService.dispatch(PortletEvent.RESIZE_STOPPED, { target: el });
      },
      close: () => {
        removePortlet(portlet);
        VCOM.PortletPool.remove(portletId);
      },
      beforeClose: () => window.confirm(translate('javascript.CONF_REMOVE_PORTLET')),
    }, options);

    if ($el.find('.ui-portlet-config').length === 0
      && $el.find('.add-portlet-config-vue').length === 0) {
      opts.configurable = false;
    }

    $el.portlet(opts);
    $el.data('portletData', portlet);
  }

  async function loadAsyncPortlet(uId) {
    const { data } = await HttpService.post(PortletEndpoint.SHOW_ASYNC_PORTLET, {
      uId,
      systemId: VCOM.systemId,
    });
    const portletHtml = jQuery(data.view).appendTo(jQuery('div.portal'));
    const options = addPermissionToPortlet(VCOM.acl, VCOM.section);
    await loadAsyncResources(data);
    initPortlet(portletHtml[0], options);
    VCOM.portletInitCallback();
  }

  async function loadAsyncDynamicPortlet(portletId, portletParams) {
    const { data } = await HttpService.post(
      PortletEndpoint.SHOW_ASYNC_DYNAMIC_PORTLET,
      {
        portletId,
        portletParams,
        systemId: VCOM.systemId,
      },
    );
    const portletHtml = jQuery(data.view).appendTo(jQuery('div.portal'));
    const portletOptions = {
      beforeClose: () => true,
      closeable: true,
      isPersistent: false,
    };
    await loadAsyncResources(data);
    initPortlet(portletHtml[0], portletOptions);
    VCOM.portletInitCallback();
  }

  async function showTicketPortlet(ticketId) {
    const ticket = VCOM.PortletPool.get(VCOM.PortletConstants.TICKET);
    if (ticket) {
      ticket.display();
      ticket.getTicket(ticketId);
      return;
    }
    const portletParams = { ticketId };
    await loadAsyncDynamicPortlet(VCOM.PortletConstants.TICKET, portletParams);
  }

  function showAlarmInfoPortlet(alarmId, alarmDate) {
    const alarmInfo = VCOM.PortletPool.get(VCOM.PortletConstants.ALARM);
    if (alarmInfo) {
      alarmInfo.load(alarmId, alarmDate);
      return;
    }
    const portletParams = { alarmId, alarmDate };
    loadAsyncDynamicPortlet(VCOM.PortletConstants.ALARM, portletParams);
  }

  function showAnlageninfoPortlet(systemId, tab) {
    const anlagenInfo = VCOM.PortletPool.get(VCOM.PortletConstants.ANLAGEN_INFO);
    if (anlagenInfo) {
      return;
    }
    const portletParams = { systemId, tab };
    loadAsyncDynamicPortlet(VCOM.PortletConstants.ANLAGEN_INFO, portletParams);
  }

  function showTabManagerPortlet() {
    const tabManager = VCOM.PortletPool.get(VCOM.PortletConstants.TAB_MANAGER);
    if (tabManager) {
      return;
    }
    loadAsyncDynamicPortlet(VCOM.PortletConstants.TAB_MANAGER);
  }

  function getPortlet(view) {
    return portlets.find((portlet) => view === portlet.view);
  }

  function hasPortlet(view) {
    return ((getPortlet(view) || document.getElementsByClassName(`portlet_${view}`).length));
  }

  function isPortletVisible(view) {
    return jQuery(`.portlet_${view}`).is(':visible');
  }

  function showPortlet(view) {
    jQuery(`.portlet_${view}`).parent().parent().parent()
      .show();
  }

  async function savePortletConfiguration(portlet, configData) {
    const data = {
      portletUId: portlet.uid.split('_')[1],
      data: configData,
    };
    jQuery(`#${portlet.uid}`).portlet('toggleConfig');
    await HttpService.post(PortletEndpoint.UPDATE_CONFIGURATION, data);
  }

  function addNewPortlet(portletId) {
    return HttpService.post(
      PortletEndpoint.ADD_NEW_PORTLET,
      {
        section: VCOM.section,
        pageId: VCOM.pageId || 0,
        portlet: portletId,
        position: JSON.stringify([[4, 4], [20, 20]]),
      },
    );
  }

  function init(section, acl) {
    contentHeight = VCOM.Layout.getContentHeight();
    contentWidth = VCOM.Layout.getContentWidth();
    calculateGrid();

    const options = addPermissionToPortlet(acl, section);
    jQuery('#page-options-control').toggle(options.closeable);

    jQuery('.portletContent').each((index, element) => {
      initPortlet(element, options);
    });

    updatePortalDimensions();

    bindListeners();
    jQuery('#butShowTabManager').on('click', showTabManagerPortlet);
  }

  return {
    getRows,
    getColumns,
    getRowHeight,
    getColumnWidth,
    init,
    bindListeners,
    resize,
    hasScript,
    loadAsyncPortlet,
    showTicketPortlet,
    showAlarmInfoPortlet,
    getScript,
    showAnlageninfoPortlet,
    hasPortlet,
    isPortletVisible,
    showPortlet,
    savePortletConfiguration,
    addNewPortlet,
  };
}
